import AddressAutoComplete from '../AddressAutoComplete'
import { BsChevronLeft as BackArrow } from 'react-icons/bs'
import { TfiLocationArrow as NavigateIcon } from 'react-icons/tfi'
import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

const AddressSelectionNew = ({
  address,
  onChange,
  onSelect,
  onClose,
  onLocationClick,
  geolocationPermission
}: {
  address: string
  onChange: (newAddress: string) => void
  onSelect: (newAddress: string) => void
  onClose: () => void
  onLocationClick: (e: React.MouseEvent) => void
  geolocationPermission: string
}) => {
  const showLocationIcon = geolocationPermission !== 'denied' && !address

  return (
    <AddressContainer>
      <AddressInputWrapper>
        <IconContainer onClick={onClose}>
          <BackArrow />
        </IconContainer>
        <AddressAutoComplete
          withIcon={true}
          isEditing={true}
          value={address}
          onChange={onChange}
          newFulfillmentModal={true}
          onSelect={onSelect}
        />
        {showLocationIcon && (
          <LocationIconContainer onClick={onLocationClick}>
            <NavigateIcon style={{ fill: 'black', transform: 'scale(-1,1)' }} />
          </LocationIconContainer>
        )}
      </AddressInputWrapper>
    </AddressContainer>
  )
}

const AddressInputWrapper = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    display: 'flex',
    alignItems: 'center'
  })
)

const AddressContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  position: 'relative',
  padding: '12px 12px 0',
  [theme.mediaQueries.viewport5]: {
    padding: '28px 28px 0'
  }
}))

const IconContainer = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    marginRight: '8px',
    cursor: 'pointer',
    padding: '4px',
    '> svg': {
      width: '14px'
    }
  })
)

const LocationIconContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  position: 'absolute',
  right: '5%',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 4px 4px',
  '> svg': {
    width: '16px',
    height: '16px'
  },
  [theme.mediaQueries.viewport7]: {
    right: '7%'
  }
}))

export default AddressSelectionNew
